"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DCI Lint Core API
 * Contains/describes the core API types for DCI Lint.
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = exports.BASE_PATH = void 0;
// Some imports not used depending on template conditions
// @ts-ignore
const axios_1 = __importDefault(require("axios"));
exports.BASE_PATH = "http://localhost".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = exports.BASE_PATH, axios = axios_1.default) {
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
exports.RequiredError = RequiredError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tYWluL3R5cGVzY3JpcHQvZ2VuZXJhdGVkL29wZW5hcGkvdHlwZXNjcmlwdC1heGlvcy9iYXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxvQkFBb0I7QUFDcEIsb0JBQW9CO0FBQ3BCOzs7Ozs7Ozs7O0dBVUc7Ozs7OztBQUlILHlEQUF5RDtBQUN6RCxhQUFhO0FBQ2Isa0RBQWlFO0FBRXBELFFBQUEsU0FBUyxHQUFHLGtCQUFrQixDQUFDLE9BQU8sQ0FBQyxNQUFNLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFFaEU7OztHQUdHO0FBQ1UsUUFBQSxrQkFBa0IsR0FBRztJQUM5QixHQUFHLEVBQUUsR0FBRztJQUNSLEdBQUcsRUFBRSxHQUFHO0lBQ1IsR0FBRyxFQUFFLElBQUk7SUFDVCxLQUFLLEVBQUUsR0FBRztDQUNiLENBQUM7QUFZRjs7OztHQUlHO0FBQ0gsTUFBYSxPQUFPO0lBR2hCLFlBQVksYUFBNkIsRUFBWSxXQUFtQixpQkFBUyxFQUFZLFFBQXVCLGVBQVc7UUFBMUUsYUFBUSxHQUFSLFFBQVEsQ0FBb0I7UUFBWSxVQUFLLEdBQUwsS0FBSyxDQUE2QjtRQUMzSCxJQUFJLGFBQWEsRUFBRTtZQUNmLElBQUksQ0FBQyxhQUFhLEdBQUcsYUFBYSxDQUFDO1lBQ25DLElBQUksQ0FBQyxRQUFRLEdBQUcsYUFBYSxDQUFDLFFBQVEsSUFBSSxJQUFJLENBQUMsUUFBUSxDQUFDO1NBQzNEO0lBQ0wsQ0FBQztDQUNKO0FBVEQsMEJBU0M7QUFBQSxDQUFDO0FBRUY7Ozs7O0dBS0c7QUFDSCxNQUFhLGFBQWMsU0FBUSxLQUFLO0lBRXBDLFlBQW1CLEtBQWEsRUFBRSxHQUFZO1FBQzFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQURJLFVBQUssR0FBTCxLQUFLLENBQVE7UUFEaEMsU0FBSSxHQUFvQixlQUFlLENBQUM7SUFHeEMsQ0FBQztDQUNKO0FBTEQsc0NBS0MifQ==